"use client"

import FilterRadioGroup from "@modules/common/components/filter-radio-group"

export type SortOptions = "stock" | "price_asc" | "price_desc" | "created_at" | "discount"

type SortProductsProps = {
  sortBy: SortOptions
  setQueryParams: (name: string, value: SortOptions) => void
  "data-testid"?: string
}

const sortOptions = [
  {
    value: "stock",
    label: "En stock primero",
  },
  {
    value: "created_at",
    label: "Novedades",
  },
  {
    value: "price_asc",
    label: "Precio: Más bajo -> Más alto",
  },
  {
    value: "price_desc",
    label: "Price: Más alto -> Más bajo",
  },
]

const SortProducts = ({
  "data-testid": dataTestId,
  sortBy,
  setQueryParams,
}: SortProductsProps) => {
  const handleChange = (value: SortOptions) => {
    setQueryParams("sortBy", value)
  }

  return (
    <FilterRadioGroup
      title="Ordenar por"
      items={sortOptions}
      value={sortBy}
      handleChange={handleChange}
      data-testid={dataTestId}
    />
  )
}

export default SortProducts
